import { apiFetch } from "../http";
const getErrorMessage = (data, fallback) => {
    if (!data)
        return fallback;
    if (typeof data.errors === "string")
        return data.errors;
    if (data.errors && typeof data.errors === "object") {
        return Object.values(data.errors).join(", ");
    }
    return data.detail || data.error || data.message || fallback;
};
const pickArray = (data, keys) => {
    if (Array.isArray(data))
        return data;
    for (const key of keys) {
        const value = data === null || data === void 0 ? void 0 : data[key];
        if (Array.isArray(value))
            return value;
    }
    return [];
};
const normalizeStatus = (data) => {
    if (!data || typeof data !== "object") {
        return { success: false, status: [] };
    }
    const status = pickArray(data, [
        "status",
        "travel_status",
        "travel_statuses",
        "statuses",
        "items",
        "results"
    ]);
    return { ...data, status };
};
export async function getTravelTypesDict(params) {
    const data = await apiFetch("/api/dict_travel_types/", {
        baseUrl: params.baseUrl,
        token: params.token,
        method: "GET"
    });
    if ((data === null || data === void 0 ? void 0 : data.success) === false) {
        throw new Error(getErrorMessage(data, "Failed to load travel types dictionary"));
    }
    return pickArray(data, ["travel_types", "traveltypes", "items", "results"]);
}
export async function getCountriesDict(params) {
    const data = await apiFetch("/api/dict_countries/", {
        baseUrl: params.baseUrl,
        token: params.token,
        method: "GET"
    });
    if ((data === null || data === void 0 ? void 0 : data.success) === false) {
        throw new Error(getErrorMessage(data, "Failed to load countries dictionary"));
    }
    return pickArray(data, ["countries", "countrys", "items", "results"]);
}
export async function getCurrenciesDict(params) {
    const data = await apiFetch("/api/dict_currencies/", {
        baseUrl: params.baseUrl,
        token: params.token,
        method: "GET"
    });
    if ((data === null || data === void 0 ? void 0 : data.success) === false) {
        throw new Error(getErrorMessage(data, "Failed to load currencies dictionary"));
    }
    return pickArray(data, ["currencies", "currencys", "currency", "items", "results"]);
}
export async function getTravelTariffTypesDict(params) {
    const data = await apiFetch("/api/dict_travel_tariff_types/", {
        baseUrl: params.baseUrl,
        token: params.token,
        method: "GET"
    });
    if ((data === null || data === void 0 ? void 0 : data.success) === false) {
        throw new Error(getErrorMessage(data, "Failed to load travel tariff types dictionary"));
    }
    return pickArray(data, ["travel_tariff_types", "travel_tariff_type", "items", "results"]);
}
export async function getTravelStatusPrivate(params) {
    const data = await apiFetch("/api/dict_travel_status_private/", {
        baseUrl: params.baseUrl,
        token: params.token,
        method: "GET"
    });
    if ((data === null || data === void 0 ? void 0 : data.success) === false) {
        throw new Error(getErrorMessage(data, "Failed to load travel status dictionary"));
    }
    return normalizeStatus(data);
}
export async function getPublicTravelStatusDict(params) {
    const data = await apiFetch("/api/dict_travel_status_public/", {
        baseUrl: params.baseUrl,
        token: params.token,
        method: "GET"
    });
    if ((data === null || data === void 0 ? void 0 : data.success) === false) {
        throw new Error(getErrorMessage(data, "Failed to load public travel status dictionary"));
    }
    return normalizeStatus(data);
}
export async function getTravelDictItems(params) {
    const data = await apiFetch("/api/dict_travel_items/", {
        baseUrl: params.baseUrl,
        token: params.token,
        method: "GET"
    });
    return data !== null && data !== void 0 ? data : [];
}
export async function getTravelDictItemsFromPointTable(params) {
    const data = await apiFetch("/api/dict_travel_items_from_point_table/", {
        baseUrl: params.baseUrl,
        token: params.token,
        method: "GET"
    });
    return data !== null && data !== void 0 ? data : [];
}
export async function getDictTravelItems(params) {
    return apiFetch("/api/dict_travel_items/", {
        baseUrl: params.baseUrl,
        token: params.token,
        method: "GET"
    });
}
export async function getTravelItemsDict(params) {
    return apiFetch(`/api/dict_travel_items/`, {
        baseUrl: params.baseUrl,
        token: params.token,
        method: "GET"
    });
}
export async function getGpxTypesDict(params) {
    return apiFetch(`/api/dict_gpx_type/`, {
        baseUrl: params.baseUrl,
        token: params.token,
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }
    });
}
